export default {
  info: 'info',
  warn: 'warn',
};
